import axios from "axios";

axios.defaults.headers.post["Content-Type"] = "application/json";

const blogBaseUrl = process.env.REACT_APP_BLOG_API
  || "https://public-api.wordpress.com/rest/v1.1/sites/bioniclylabs.wordpress.com/posts";

const blogAPI = axios.create({
  baseURL: blogBaseUrl
});

const twitterAPI = axios.create({
    baseURL: 'https://4g5lv13wy6.execute-api.us-east-2.amazonaws.com/bioniclymirror/tweetbionicly'
    //baseURL: '/services/bionictweets.php'
});


export {
    blogAPI,
    twitterAPI
};
